module.exports = __webpack_public_path__ + "img/20.6adb5603.png";